import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {MatFormFieldAppearance} from "@angular/material/form-field";
import {Observable, of} from "rxjs";
import {MetricComponentObjects} from '../../classes/metric-component-object';
import {selectMetricComponentObjects, selectMetricSourceGroups} from '../../store/selectors';
import {selectDataSetMetricsGroupComponentObjects} from '../../store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {
  DatasetMetricsGroupComponentObject,
  DatasetMetricsGroupComponentObjects
} from '../../classes/dataset-metrics-group-component-object';

@Component({
  selector: 'app-metric-selector',
  templateUrl: './metric-selector.component.html',
  styleUrls: ['./metric-selector.component.scss']
})
export class MetricSelectorComponent {
  @Input() public form: FormGroup;
  @Input() public control: FormControl;
  @Input() public controlName: string = 'metric';
  @Input() public label: string = 'Metric';
  @Input() public suppressLabel: boolean = false;
  @Input() public centerPosition: boolean = false;
  @Input() public button: boolean = false;
  @Input() public buttonIcon: string = 'add';
  @Input() public appearance: MatFormFieldAppearance = 'outline';

  public categories$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectDataSetMetricsGroupComponentObjects);
  public sources$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectMetricSourceGroups);
  public metrics$: Observable<MetricComponentObjects> = this._store.select(selectMetricComponentObjects);

  @Input('metrics') public set metrics(metrics: MetricComponentObjects) {
    const categories: DatasetMetricsGroupComponentObjects = [];
    const sources: DatasetMetricsGroupComponentObjects = [];

    for (const metric of metrics) {
      if (metric.payload.relationships.data_set_metrics_group.data && !categories.find(category => category.payload === metric.payload.relationships.data_set_metrics_group.data)) {
        const category: DatasetMetricsGroupComponentObject = new DatasetMetricsGroupComponentObject(metric.payload.relationships.data_set_metrics_group.data);

        category.init(metrics);
        categories.push(category);
      }

      if (metric.payload.relationships.data_source.data && !sources.find(source => source.payload === metric.payload.relationships.data_source.data)) {
        const source = new DatasetMetricsGroupComponentObject(metric.payload.relationships.data_source.data);

        source.init(metrics);
        sources.push(source);
      }
    }

    this.categories$ = of(categories);
    this.sources$ = of(sources);
    this.metrics$ = of(metrics);
  }

  constructor(
    private readonly _store: Store<AppState>
  ) {}

}
